import { itamRoute } from '@jira/router-routes__itam-routes/src/itamRoute.tsx';
import { itamEntryPoint } from '@jira/spa-apps__itam/src/itamEntryPoint.entrypoint.tsx';
import { hamViewsResource } from '@jira/router-resources__itam-ham-dashboard/src/hamViewsResource.tsx';
import { verticalInstantiationResource } from '@jira/router-resources__itam/src/verticalInstantiationResource.tsx';
import { avsWorkspaceResource } from '@jira/router-resources__itam/src/avsWorkspaceResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { itamDashboardsSemanticModelResource } from '@jira/router-resources__viz-platform/src/itamDashboardsSemanticModelResource.tsx';
import { MenuIdItam } from '@jira/navigation-apps__constants/src/MenuIdItam.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getCommonGlobalResources } from '@jira/router-routes__issue-navigator-entries/src/common/getCommonGlobalResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const itamAppPageEntryPoint = createPageEntryPoint({
	main: itamEntryPoint,
});

export const itamRouteEntry: Route = createEntry(itamRoute, () => ({
	group: 'servicedesk',
	layout: globalLayout,
	navigation: {
		menuId: MenuIdItam,
	},
	resources: [
		...getCommonGlobalResources(),
		workspaceResource,
		verticalInstantiationResource,
		resourceWithCondition(() => fg('itam_ftw'), avsWorkspaceResource),
		hamViewsResource,
		resourceWithCondition(
			() => fg('platform_avp_enable_jsm_assets_metrics'),
			itamDashboardsSemanticModelResource,
		),
	],
	entryPoint() {
		return fg('itam_ftw') ? itamAppPageEntryPoint : notFoundPageEntrypoint;
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
